import makeStyles from "@material-ui/core/styles/makeStyles";

const useDrawerStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper,
		"& div:nth-child(2)": {
			whiteSpace: "nowrap",
			overflow: "scroll",
			"& span": {
				display: "initial",
			},
		},
	},
	nested: {
		paddingLeft: `${theme.spacing(4)}px !important`,
	},
}));

export default useDrawerStyles;
